import React, { FC, useMemo } from 'react';
import {
  ITrajectoryDetail,
  TrajectorySectionCode,
  trajectorySectionCodeLookup,
} from '../../../../../config/api/models/Trajectory';
import { useUser } from '../../../../shared/hooks';
import { StudentSidebarContent } from './StudentSidebarContent';
import { AuthorSidebarContent } from './AuthorSidebarContent';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { useParams } from 'react-router';
import { UrlParams } from 'src/modules/shared/types';
import { usePagesByType } from 'src/modules/trajectory/hooks';
import { TeacherSidebarContent } from './TeacherSidebarContent';

type Props = {
  onPublish?: () => void;
  onUnPublish?: () => void;
};

const TrajectorySidebar: FC<Props> = () => {
  // this will get me the params without depending on props
  const currentSectionCode = useAppSelector((state) => state.trajectories.currentSectionCode);

  const { isAuthor, isStudent, isTeacher } = useUser();
  const { seriesId } = useParams<UrlParams>();
  const trajectory = useAppSelector((state) => state.trajectories.trajectory);
  const currentBookId = useAppSelector((state) => state.trajectories.currentBookId);
  const viewMode = useAppSelector((state) => state.trajectories.viewMode);
  const sidebarTabsVisible = useAppSelector((state) => state.trajectorySidebar.sidebarTabsVisible);
  const pages = usePagesByType(
    trajectorySectionCodeLookup[currentSectionCode as TrajectorySectionCode]
  );
  const currentPageId = useMemo(() => pages?.data?.[0]?.id ?? seriesId, [pages, seriesId]);

  return (
    <>
      {isAuthor && (
        <AuthorSidebarContent
          bookId={currentBookId as string}
          trajectory={trajectory as ITrajectoryDetail}
          pageId={currentPageId}
          showTabs={sidebarTabsVisible}
          sectionCode={currentSectionCode as TrajectorySectionCode}
        />
      )}
      {isTeacher && (
        <TeacherSidebarContent
          trajectory={trajectory as ITrajectoryDetail}
          pageId={currentPageId}
          mode={viewMode}
          showTabs
          sectionCode={currentSectionCode as TrajectorySectionCode}
        />
      )}

      {isStudent && <StudentSidebarContent showTabs={sidebarTabsVisible} />}
    </>
  );
};

export default TrajectorySidebar;
